import { request } from '@/utils/request'

// 钱包
const permissionApi = {
  getPermissionList: () => request.get('admin_routes/permissions'),

  getRoleList: params => request.get('permission/role/index', params),
}

export { permissionApi }